export default "__VITE_ASSET__BkmAEnq6__"